import { createContext } from 'react';
import { ApiClient } from '~/common';

const context = createContext<ApiClient | undefined>(undefined);

const { Provider, Consumer } = context;

export { Provider, Consumer };
export default context;
